import { Form } from "@client/content/controls";
import { getRootContainerProps, getRootContainerPropsDep } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo } from "@client/controls/Form/component";
import EmailInput from "@client/controls/Inputs/Email/component";
import { FormModal } from "@client/controls/Modal/Modals";
import { type FormModalButton, type FormModalProps } from "@client/controls/Modal/Modals/Form/component";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormat } from "@common/lib/i18n";
import React from "react";
import api from "../api";

export type EmailModalFormData = RootContainerProps & {
  obfuscatedEmail: string;
  apiInfo: ModuleApiInfo;
  ticketId: string;
  scheduleId: string;
};

type Props = Omit<FormModalProps, "buttons" | "fields"> & EmailModalFormData;
const EmailCheckModal = (props: Props) => {
  const i18n = useI18n();

  const buttons = React.useMemo(
    (): FormModalButton[] => [
      (p) => (
        <ModuleButton
          {...getRootContainerProps(props)}
          onClick={p.onClick}
          isDisabled={p.isBusy}
          caption={i18n.openTicket}
        />
      )
    ],
    getRootContainerPropsDep(props)
  );

  const fields = React.useMemo(
    (): FormFieldInfo[] => [
      {
        Component: EmailInput,
        isRequired: true,
        label: i18n.email,
        name: "email",
        defaultValue: "",

        validation: async (i18n, data) => {
          const res = fieldValidation.email(i18n, data);
          if (res) return res;

          const apiResult = await api.checkEmail(props.apiInfo, {
            ticketId: props.ticketId,
            scheduleId: props.scheduleId,
            email: data
          });

          return apiResult.response?.data ? null : i18n.incorrectEmail;
        }
      }
    ],
    []
  );

  return (
    <FormModal
      {...props}
      formProps={getRootContainerProps(props)}
      Form={Form}
      fields={fields}
      buttons={buttons}
      className="wsc_ticket_check_email_modal"
      width={400}
      buttonsPosition="left"
      topInfo={
        <div
          dangerouslySetInnerHTML={{
            __html: i18nFormat(i18n.infoEmailConfirmation, ["EMAIL", props.obfuscatedEmail])
          }}
        />
      }
    />
  );
};
export default EmailCheckModal;
